var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurplusResourceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.806641 33.0214C1.67966 81.736 72.9177 82.7838 69.7749 35.8154C73.4416 -9.93089 7.79081 -12.8995 0.806641 33.0214ZM45.6797 24.9897C45.6797 24.9897 46.3781 53.2756 42.7114 53.101C22.2827 53.974 27.3465 59.2118 25.0767 25.6879C11.1083 16.4338 46.2037 10.6722 47.9497 21.6723C47.9497 22.7199 47.0765 23.9421 45.6797 24.9897Z",
    fill: "#203563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurplusResourceIcon);
export default __webpack_public_path__ + "static/media/surplus-resource-icon.0c685f28747847bcd394a67cecc8a79d.svg";
export { ForwardRef as ReactComponent };